import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import Hyperlink from "source/app/presentation/Shared/Link/Hyperlink";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { ReadState, ReadStateOrDefault } from "source/app/services/UI/State/ReadState";
import { SetState } from "source/app/services/UI/State/SetState";
import { SubscribeToSharedState } from "source/app/services/UI/State/ShareState";
import { ApplyBodyFont } from "source/app/services/UI/Fonts/BodyFont";
import { SetUseAnopenscrollFontAsync } from "source/app/services/UI/Fonts/FontPreference";
import { labelStyleClass, compactRowStyleClass, dateOffsetButtonStyleClass, dateOffsetStepperStyleClass } from "./PlayerMenuStyles";

export function CompactFontSwitcher() {
    const [useAnopenscrollFont, setUseAnopenscrollFont] = React.useState(
        ReadStateOrDefault(
            ESharedFunction.FontSwitcher_useAnopenscrollFont,
            false
        )
    );

    SubscribeToSharedState(
        ESharedFunction.FontSwitcher_useAnopenscrollFont,
        setUseAnopenscrollFont
    );

    React.useEffect(() => ApplyBodyFont(useAnopenscrollFont), [
        useAnopenscrollFont,
    ]);

    return (
        <label className={compactRowStyleClass}>
            <Glyphicon icon={EGlyphicon.font} />
            <span className={labelStyleClass}>Switch font</span>
            <input
                type="checkbox"
                checked={useAnopenscrollFont}
                onChange={(event) =>
                    SetUseAnopenscrollFontAsync(event.currentTarget.checked)
                }
                className={StyleClassAuto({
                    float: "right",
                    marginTop: "3px",
                })}
            />
        </label>
    );
}

export function CompactSystemDateOffset() {
    const [value, setValue] = React.useState<number>(
        ReadState<number>(ESharedFunction.SystemDateWarning_offset) ?? 0
    );

    function ChangeSystemDateOffset(newValue: number) {
        setValue(newValue);
        SetState(ESharedFunction.SystemDateWarning_offset, newValue);
    }

    return (
        <div className={compactRowStyleClass}>
            <Glyphicon icon={EGlyphicon.calendar} />
            <span className={labelStyleClass}>Date offset</span>
            <span
                className={dateOffsetStepperStyleClass}
            >
                <Hyperlink
                    whenClicked={() => ChangeSystemDateOffset(value - 1)}
                    classes={dateOffsetButtonStyleClass}
                >
                    <Glyphicon icon={EGlyphicon.minus} />
                </Hyperlink>
                <span
                    className={StyleClassAuto({
                        minWidth: "18px",
                        textAlign: "center",
                    })}
                >
                    {value}
                </span>
                <Hyperlink
                    whenClicked={() => ChangeSystemDateOffset(value + 1)}
                    classes={dateOffsetButtonStyleClass}
                >
                    <Glyphicon icon={EGlyphicon.plus} />
                </Hyperlink>
            </span>
        </div>
    );
}
